import actions from './actions';

const { GET_CLIENT_SECRET_BEGIN, GET_CLIENT_SECRET_SUCCESS, GET_CLIENT_SECRET_ERR, DELETE_CARD_BEGIN, DELETE_CARD_SUCCESS, DELETE_CARD_ERR, GET_CUSTOMER_CARD_BEGIN, GET_CUSTOMER_CARD_SUCCESS, GET_CUSTOMER_CARD_ERR, SET_DEFAULT_CARD_BEGIN, SET_DEFAULT_CARD_SUCCESS, SET_DEFAULT_CARD_ERR } = actions;

const initState = {
  list: null,
  loading: false,
  error: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const ManagePaymentReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_CLIENT_SECRET_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_CLIENT_SECRET_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_CLIENT_SECRET_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_CARD_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DELETE_CARD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case GET_CUSTOMER_CARD_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_CUSTOMER_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_CUSTOMER_CARD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case SET_DEFAULT_CARD_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case SET_DEFAULT_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SET_DEFAULT_CARD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default ManagePaymentReducer;
